import React from 'react'
import { t } from 'ttag'

import { useTitleChange } from '../../util/hooks'

const ChoosingMajor = () => {
  useTitleChange(t`Choosing a Field of Study`)

  return (
    <div className="container" id="choosingmajor">
      <p className="instructions">
        {t`There are many ways to go about choosing a course of study. Generally, it is
                best to figure out what you would like to do and then choose a a program that leads to it. The system
                provides you with many avenues for finding a career that might suit you well. Once you find it, you can
                find the common courses of study on any occupational profile page.`}
      </p>
      <p className="instructions">
        {t`If you can't figure out what you want to do or just want to explore what is out
                there, we put together this module so that you can take a look at programs in a variety of ways to help
                you narrow down your choices. For each item below, you can read the brief description of what you will
                be looking at to pick what you are interested in exploring.`}
      </p>

      <br />
      <h2>{t`To get started, choose one of the options below:`}</h2>

      <div className="mainsection">
        <a className="box majorswage" href="/majors/choosing/wage"></a>
        <div className="text">
          <h3>{t`Highest Wages`}</h3>
          <p>
            {t`Choose this option to see a list of programs displayed by the average wage of the occupations
                    that it might lead to.`}
          </p>
        </div>
        <div className="navlink">
          <a href="/majors/choosing/wage">{t`Explore these Fields`}</a>
        </div>
      </div>

      <div className="mainsection">
        <a className="box majorsgrowth" href="/majors/choosing/growth"></a>
        <div className="text">
          <h3>{t`Most Job Openings`}</h3>
          <p>
            {t`Choose this option to see a list of programs displayed by the total number of projected
                    openings in the occupations that it might lead to.`}
          </p>
        </div>
        <div className="navlink">
          <a href="/majors/choosing/growth">{t`Explore these Fields`}</a>
        </div>
      </div>

      <div className="mainsection">
        <a className="box majorscompletions" href="/majors/choosing/completions"></a>
        <div className="text">
          <h3>{t`Number of Graduates`}</h3>
          <p>
            {t`Choose this option to see a list of programs displayed by the total number of students who
                    graduated with this degree in the last year.`}
          </p>
        </div>
        <div className="navlink">
          <a href="/majors/choosing/completions">{t`Explore these Fields`}</a>
        </div>
      </div>
    </div>
  )
}

export default ChoosingMajor
